import { render, staticRenderFns } from "./areaCascader.vue?vue&type=template&id=739a1979"
import script from "./areaCascader.vue?vue&type=script&lang=js"
export * from "./areaCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports